import React from 'react';
import { SxProps, Theme } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DosenTooltip from './DosenTooltip';
import { useIsMobileApp } from '../../mobile/mobileApp';

/**
 * The house info icon: a grey "i" placed right after the text it explains,
 * with the house tooltip. Hover-for-more keeps the default arrow cursor; the
 * hand is only for things you click. On the phone a tap opens it.
 *
 * `accent` is the one orange variant, kept for the icon that explains why
 * Elliott recommends something.
 */
const InfoTip: React.FC<{
  title: React.ReactNode;
  placement?: 'bottom' | 'bottom-start' | 'bottom-end' | 'right' | 'left' | 'top';
  accent?: boolean;
  sx?: SxProps<Theme>;
}> = ({ title, placement = 'bottom', accent = false, sx }) => {
  const isMobileApp = useIsMobileApp();
  return (
    <DosenTooltip tapOnPhone title={title} placement={placement}>
      <InfoOutlinedIcon
        aria-hidden={false}
        tabIndex={0}
        // Phone: a tap on the icon opens its tip, never a row or button around it.
        onClick={isMobileApp ? (e: React.MouseEvent) => e.stopPropagation() : undefined}
        sx={[
          {
            fontSize: 15,
            color: accent ? '#F79420' : '#B6B6B6',
            cursor: 'default',
            verticalAlign: 'middle',
            flexShrink: 0,
            outline: 'none'
          },
          ...(Array.isArray(sx) ? sx : [sx])
        ]}
      />
    </DosenTooltip>
  );
};

export default InfoTip;
